import React from 'react';
import { observer } from 'mobx-react'; 
import RenderPaymentMethod from './RenderPaymentMethod'; 
import { CustomButton, CustomLabel, FlexContainer, UtilityMethods } from '@mindmemobile/mm-shared-global';
import { PaymentMethodModel } from '../models';
import { PaymentMethodUtil } from '../utils';
import { PaymentMethodPriority } from '../enums';

interface PaymentMethodSelectorProps {
    paymentMethod: PaymentMethodModel;
    className?: string;
    hideExpiration?: boolean;
}

const PaymentMethodDescripton: React.FC<PaymentMethodSelectorProps> = ({
    paymentMethod,
    className,
    hideExpiration = false,
}) => {
    return (
        <FlexContainer
            padding="0px 0px 5px"
            key={paymentMethod.id}
            spacing={10}
            alignItems="center"
            className={className}
        >
            <RenderPaymentMethod paymentMethod={paymentMethod} />
            {paymentMethod.card && hideExpiration !== true && (
                <CustomLabel>
                    Expires {UtilityMethods.months[parseInt(paymentMethod.card.expiryMonth)] || ''}{' '}
                    {paymentMethod.card.expiryYear}
                </CustomLabel>
            )}

            <CustomButton
                bgColor={PaymentMethodUtil.getColors(paymentMethod.priority).bgColor}
                color={PaymentMethodUtil.getColors(paymentMethod.priority).color}
                className="status-btn"
            >
                {PaymentMethodPriority[paymentMethod.priority]}
            </CustomButton>
        </FlexContainer>
    );
};

export default observer(PaymentMethodDescripton);
